export function transformLineBreakToBR(rawString) {
  return (rawString || '').replace(/(?:\r\n|\r|\n|\u21b5)/g, '<br />');
}
